import React from 'react';
import { services } from '../../constants/content';
import { Heart, Baby, HeartHandshake, MessageCircle } from 'lucide-react';

import type { LucideIcon } from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  heart: Heart,
  baby: Baby,
  heartHandshake: HeartHandshake,
  messageCircle: MessageCircle,
};

// Extracted icon component for proper reconciliation
const ServiceIcon: React.FC<{ iconName: string }> = ({ iconName }) => {
  const Icon = iconMap[iconName];
  return Icon ? <Icon size={28} className="text-contessa-500" /> : null;
};

const Services: React.FC = () => {
  return (
    <section id="servicios" className="py-16 bg-contessa-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="w-24 h-1 bg-contessa-300 mx-auto mb-8"></div>
        <div className="text-center mb-8">
          <span className="inline-flex items-center justify-center rounded-full bg-contessa-50 px-4 py-1 text-xs font-semibold uppercase tracking-[0.3em] text-contessa-500 mb-8">
            Mis Servicios
          </span>

          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="mt-1 text-sm text-contessa-700">
            Te ofrezco un acompañamiento integral en cada etapa de tu
            maternidad, adaptado a tus necesidades específicas.              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="bg-contessa-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <ServiceIcon iconName={service.icon} />
              </div>
              <h3 className="text-xl font-serif font-bold text-contessa-800 mb-3">
                {service.title}
              </h3>
              <p className="text-contessa-600">{service.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;